export const PAGE_SIZE_DEFAULT = 25;
export const PAGE_SIZE_MAX = 200;
/** Single locale source for i18n, profiles, questionnaires and documentation. */
export const LOCALE_CONFIG = {
    tr: { direction: 'ltr', baseLocale: 'tr', intlLocale: 'tr-TR', nativeName: 'Türkçe' },
    fr: { direction: 'ltr', baseLocale: 'fr', intlLocale: 'fr-FR', nativeName: 'Français' },
    es: { direction: 'ltr', baseLocale: 'es', intlLocale: 'es-ES', nativeName: 'Español' },
    de: { direction: 'ltr', baseLocale: 'de', intlLocale: 'de-DE', nativeName: 'Deutsch' },
    en: { direction: 'ltr', baseLocale: 'en', intlLocale: 'en-GB', nativeName: 'English' },
};
export const SUPPORTED_LOCALES = Object.keys(LOCALE_CONFIG);
/** Retained only for parsing historic snapshots and archived translations. */
export const RETIRED_LOCALES = ['ru'];
export const KNOWN_LOCALES = [...SUPPORTED_LOCALES, ...RETIRED_LOCALES];
export const DEFAULT_LOCALE = 'tr';
export const HELP_EMERGENCY_LOCALE = 'de';
export function isSupportedLocale(value) {
    return Object.hasOwn(LOCALE_CONFIG, value);
}
export function localeDirection(locale) {
    const candidate = isSupportedLocale(locale) ? locale : locale.split('-')[0];
    return candidate !== undefined && isSupportedLocale(candidate)
        ? LOCALE_CONFIG[candidate].direction
        : 'ltr';
}
/** Anzeigewaehrung, solange kein abweichender Mandantenwert vorliegt. */
export const DEFAULT_CURRENCY = 'EUR';
/** Tabellenexporte unterstützen in allen Modulen dieselben Formate. */
export const EXPORT_FORMATS = ['csv', 'xlsx'];
/**
 * Obergrenze eines einzelnen Datei-Uploads im Multipart-Plugin. Der Wert deckt
 * den größten fachlichen Fall ab (Gesprächsaufzeichnungen); jede Route setzt
 * zusätzlich ihre eigene, engere Grenze.
 */
export const UPLOAD_MAX_FILE_BYTES = 50 * 1024 * 1024;
/** Serializes tenant delivery admission with changes to its mail policy. */
export const TENANT_MAIL_LOCK_NAMESPACE = 1296124236;
//# sourceMappingURL=app.js.map